import React, { useState } from 'react';
import { Bell, Users, User, Wrench, Send } from 'lucide-react';
import '../../../../assets/css/screens/admin/dashboard/adminnotification/AdminNotification.css';

// ── Dummy sent notifications ──────────────────────────────────
const INITIAL_SENT = [
  {
    id: 1,
    title:   'System Maintenance',
    message: 'Scheduled maintenance on March 28',
    to:      'All Users',
    date:    'Mar 25, 2026',
  },
  {
    id: 2,
    title:   'New Feature Launch',
    message: 'Bid jobs feature is now live!',
    to:      'Providers',
    date:    'Mar 22, 2026',
  },
  {
    id: 3,
    title:   'Special Discount',
    message: 'Get 20% off on your next booking',
    to:      'Customers',
    date:    'Mar 20, 2026',
  },
];

// ── Audience pill options ─────────────────────────────────────
const AUDIENCE_OPTIONS = [
  { value: 'All Users',  icon: <Bell size={14} /> },
  { value: 'Customers',  icon: <User size={14} /> },
  { value: 'Providers',  icon: <Wrench size={14} /> },
];

const AdminNotifications = () => {
  const [title,    setTitle]    = useState('');
  const [message,  setMessage]  = useState('');
  const [audience, setAudience] = useState('All Users');
  const [sentList, setSentList] = useState(INITIAL_SENT);
  const [sending,  setSending]  = useState(false);
  const [flashId,  setFlashId]  = useState(null);

  // ── Send handler ──────────────────────────────────────────
  const handleSend = () => {
    if (!title.trim() || !message.trim()) return;
    setSending(true);
    setTimeout(() => {
      const newNotif = {
        id:      Date.now(),
        title:   title.trim(),
        message: message.trim(),
        to:      audience,
        date:    new Date().toLocaleDateString('en-US', {
          month: 'short', day: 'numeric', year: 'numeric',
        }),
      };
      setSentList(prev => [newNotif, ...prev]);
      setFlashId(newNotif.id);
      setTitle('');
      setMessage('');
      setAudience('All Users');
      setSending(false);
      setTimeout(() => setFlashId(null), 1800);
    }, 900);
  };

  return (
    <div className="an-page">
      <div className="an-container">

        <h2 className="an-heading">Notifications</h2>

        {/* ════ SEND CARD ════ */}
        <div className="an-send-card">
          <p className="an-send-label">Send Notification</p>

          {/* Title */}
          <input
            className="an-input"
            type="text"
            placeholder="Notification title"
            value={title}
            onChange={e => setTitle(e.target.value)}
          />

          {/* Message */}
          <textarea
            className="an-textarea"
            placeholder="Notification message..."
            value={message}
            onChange={e => setMessage(e.target.value)}
            rows={4}
          />

          {/* Audience pills */}
          <div className="an-pills">
            {AUDIENCE_OPTIONS.map(opt => (
              <button
                key={opt.value}
                type="button"
                className={`an-pill${audience === opt.value ? ' an-pill--active' : ''}`}
                onClick={() => setAudience(opt.value)}
              >
                {opt.icon}
                {opt.value}
              </button>
            ))}
          </div>

          {/* Send button */}
          <button
            className={`an-send-btn${sending ? ' an-send-btn--loading' : ''}`}
            onClick={handleSend}
            disabled={sending || !title.trim() || !message.trim()}
            type="button"
          >
            {sending
              ? <span className="an-spinner" />
              : <><Send size={14} /> Send Notification</>
            }
          </button>
        </div>

        {/* ════ SENT NOTIFICATIONS ════ */}
        <h5 className="an-subheading">Sent Notifications</h5>

        <div className="an-notif-list">
          {sentList.map((notif, i) => (
            <div
              key={notif.id}
              className={`an-notif-card${notif.id === flashId ? ' an-notif-card--flash' : ''}`}
              style={{ animationDelay: notif.id === flashId ? '0s' : `${i * 0.06}s` }}
            >
              <div className="an-notif-icon">
                <Bell size={16} />
              </div>
              <div className="an-notif-body">
                <p className="an-notif-title">{notif.title}</p>
                <p className="an-notif-msg">{notif.message}</p>
                <div className="an-notif-meta">
                  <span className="an-notif-to">To: {notif.to}</span>
                  <span className="an-notif-date">{notif.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default AdminNotifications;